/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Aria_Home_LinkInputs */

const en_nav_aria_home_link = /** @type {(inputs: Nav_Aria_Home_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening home page`)
};

const es_nav_aria_home_link = /** @type {(inputs: Nav_Aria_Home_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página principal de Listening`)
};

/**
* | output |
* | --- |
* | "Listening home page" |
*
* @param {Nav_Aria_Home_LinkInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_aria_home_link = /** @type {((inputs?: Nav_Aria_Home_LinkInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Aria_Home_LinkInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_aria_home_link(inputs)
	return en_nav_aria_home_link(inputs)
});